import { axiosInstance } from "./apiInstance";

export const resetPasswordResendOtp = ({ values }) => {
  const { data } = axiosInstance.post("api/inkle/users/reset-password/", {
    email: values.email_id,
    mobile: values.email_id ? null : values.phone_no,
  });
  return data;
};
